'use client'

import { useParams } from 'next/navigation'

interface LocaleState {
  locale: string
  isJapanese: boolean
  isEnglish: boolean
  isSimplifiedChinese: boolean
  isTraditionalChinese: boolean
  isKorean: boolean
}

export const useLocale = (): LocaleState => {
  const params = useParams<{ locale: string }>()
  const { locale = '' } = params || {}

  return {
    locale,
    isJapanese: locale === 'ja',
    isEnglish: locale === 'en',
    isSimplifiedChinese: locale === 'zh-Hans',
    isTraditionalChinese: locale === 'zh-Hant',
    isKorean: locale === 'ko',
  }
}
